import * as React from "react";
const RANGE_VALUE_SEPARATOR = "-";
const formatRange = (value) => {
  const [min, max] = value.split(RANGE_VALUE_SEPARATOR);
  if (min && max) {
    return `${min} - ${max}`;
  }
  return value;
};
const RiskScoreRangeLabel = ({ value }) => /* @__PURE__ */ React.createElement("span", null, formatRange(value));
export default RiskScoreRangeLabel;
